import { parseISOToDateTime, endOfDay, now, toDateId } from '@calendly/datetime'
import { parseQuery } from '@calendly/http-tools'

import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'
import { syncUrlParameters } from 'actions/navigation'
import { eventTypeSelector } from 'root-api'
import { timezoneSelector } from 'selectors'

export const selectCalendarDay = (day, isFromKeyboard) => (dispatch, getState) => {
  const state = getState()
  const { name } = eventTypeSelector(state)
  GoogleAnalytics.userTrackEvent('invitee_select_day', name)
  FbPixel.trackCustom('invitee_select_day', { event_type_name: name })
  dispatch({ type: 'SELECT_CALENDAR_DAY', day, isFromKeyboard })
  dispatch(syncUrlParameters())
}

export const deselectCalendarDay = () => (dispatch) => {
  dispatch({ type: 'DESELECT_CALENDAR_DAY' })
  dispatch(syncUrlParameters())
}

const isValidDateInFuture = (date, timezone) => {
  if (!date?.isValid) return false
  const dayEnd = endOfDay(date)
  const currentTime = now(timezone)
  return toDateId(dayEnd) >= toDateId(currentTime)
}

const selectDateByString = (dateString, dispatch, getState) => {
  const date = parseISOToDateTime(dateString)
  const timezone = timezoneSelector(getState())

  if (isValidDateInFuture(date, timezone)) {
    dispatch({
      type: 'SELECT_CALENDAR_DAY',
      day: { id: toDateId(date), date }
    })
  } else {
    dispatch(syncUrlParameters())
  }
}

export const preselectCalendarDay = (query) => (dispatch, getState) => {
  const params = parseQuery(query)
  if (!params.date) return

  selectDateByString(params.date, dispatch, getState)
}
